import { useDispatch, useSelector } from 'react-redux'
import Input from '../../../../../UI/Input/Input'
import { setLocal } from '../../../../../../redux/action/local'
import props from '../../../../../../redux/props'

const RentalStatus = () => {
  const translations = useSelector((state) => state.translations)
  const purchaseProfile = useSelector((state) => state.PURCHASE_PROFILE)
  const dispatch = useDispatch()

  const update = (key) => (value) => {
    const updatePurchaseProfile = { ...purchaseProfile, rentalStatus: { ...purchaseProfile.rentalStatus, [key]: value } }
    // dispatch(setNewPurchaseProfile(updatePurchaseProfile))
    dispatch(setLocal(props.PURCHASE_PROFILE, updatePurchaseProfile))
  }

  return (
    <div className="wrapper">
      <div className="group">
        <div className="label">{translations['my-objects.pipeline.location-criteria.rental-status.from']}</div>
        <div className="values">
          <Input
            type="number"
            value={purchaseProfile.rentalStatus.from}
            onChange={update('from')}
            placeholder={translations['my-objects.pipeline.location-criteria.rental-status.from']}
            suffix={translations['percent.symbol']}
          />
        </div>
      </div>
      <div className="group">
        <div className="label">{translations['my-objects.pipeline.location-criteria.rental-status.until']}</div>
        <div className="values">
          <Input
            type="number"
            value={purchaseProfile.rentalStatus.until}
            onChange={update('until')}
            placeholder={translations['my-objects.pipeline.location-criteria.rental-status.until']}
            suffix={translations['percent.symbol']}
          />
        </div>
      </div>
    </div>
  )
}

export default RentalStatus
